import React from 'react';
import { useIntl } from 'react-intl';
import { formatListValue } from '@/shared/components/FormattedListValue';
import FieldChange from './FieldChange';
import EnumChange from './EnumChange';
import messages from './FieldMessages';

const RelationLinkProperty = props => {
  const intl = useIntl();
  const { log, relations, users } = props;

  const isEnum = () => {
    const value = log.oldValue.Value || log.newValue.Value;
    return value && value.hasOwnProperty('Value') && value.hasOwnProperty('Name');
  };

  const displayLogLine = () => {
    const transformedLogLine = {
      ...log,
      oldValue: log.oldValue.Value,
      newValue: log.newValue.Value,
    };

    if (isEnum()) {
      return <EnumChange log={transformedLogLine} />;
    }

    return <FieldChange log={transformedLogLine} users={users} relations={relations} />;
  };

  const relation = relations[log.oldValue.RelationId];
  // Older lines don't carry the link type
  const linkType = log.newValue.LinkType ?? log.oldValue.LinkType;

  return (
    <span>
      {displayLogLine(log.newValue)}{' '}
      {linkType === null || linkType === undefined
        ? intl.formatMessage(messages.ForRelationLinkWith, { relation })
        : intl.formatMessage(messages.ForRelationLinkOfTypeWith, {
            relation,
            linkType: formatListValue({ intl, list: 'linktypeto', id: linkType }),
          })}
    </span>
  );
};

export default RelationLinkProperty;
